import React, { useState } from 'react'
import { Button, Col, FloatingLabel, Form, FormControl, Modal, Row } from 'react-bootstrap'
import { updateAppointment } from '../../../../Adaptor/TUBSIS/controllers/Appointments/Appointments'
import { GetRestrictedAppointmentDatesOutput } from '../../../../Adaptor/TUBSIS/controllers/RestrictedAppointmentDates/models/getRestrictedAppointmentDates'
import { updateRestrictedAppointmentDates } from '../../../../Adaptor/TUBSIS'
import moment from 'moment'

type Props = {restriction: GetRestrictedAppointmentDatesOutput}

const RestrictedAppointmentDatesUpdate : React.FC<Props> = ({ restriction }) => {
  
    const [showModal, setShowModal] = useState(false);

    const [startDate, setStartDate] = useState<Date | null>(null);
    const [description, setDescription] = useState<string | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);

    const clearForm = () => {
        setStartDate(null)
        setEndDate(null)
    }

    const openModal = () => {
        clearForm()
        setStartDate(restriction.startDate)
        setEndDate(restriction.endDate)
        setDescription(restriction.descriptions)
        setShowModal(true);
    };

    const closeModal = () => {
        clearForm()
        setShowModal(false);
        //window.location.reload();
    };

    const parseDateStringToDate = (dateString: string): Date | null => {
        // Tarih stringinin uygun formatta olup olmadığını kontrol et
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) return null;
    
        // Yıl, ay ve gün bilgilerini al
        const year = parseInt(match[1]);
        const month = parseInt(match[2]) - 1; // JavaScript'te aylar 0'dan başlar, bu yüzden 1 çıkarıyoruz.
        const day = parseInt(match[3]);
    
        if (month < 0 || month > 11 || day < 1 || day > 31) return null;
    
        const parsedDate = new Date(year, month, day);
        
        // Oluşturulan tarihin geçerli olup olmadığını kontrol et
        const currentDate = new Date();
        if (parsedDate <= currentDate) return null;
    
        return parsedDate;
    };

    const [isValidStartDate, setIsValidStartDate] = useState<boolean>(true);
    const [isValidEndDate, setIsValidEndDate] = useState<boolean>(true);

    const handleItemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (name === 'startDate') {
            const parsedDate = parseDateStringToDate(value)
            setStartDate(parsedDate);
            setIsValidStartDate(parsedDate !== null);
        } else if (name === 'endDate') {
            const parsedDate = parseDateStringToDate(value)
            setEndDate(parsedDate);
            setIsValidEndDate(parsedDate !== null);
        } else if (name === 'description') {
            setDescription(value??"");      
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement | HTMLButtonElement>) => {
        e.preventDefault();
        
        if (!isValidStartDate || !isValidEndDate || startDate === null || endDate === null ) {
            return;
        }
    
        let parsedStartDate = new Date(startDate)
        let parsedEndDate = new Date(endDate)

        parsedStartDate.setHours(parsedStartDate.getHours() + 3)
        parsedEndDate.setHours(parsedEndDate.getHours() + 3)

        const requestModel = {
            id: restriction.id,
            startDate: new Date(parsedStartDate),
            endDate: new Date(parsedEndDate),
            descriptions: description??""
        };

        const response = await updateRestrictedAppointmentDates(requestModel);

        if (response.success){
            alert(response.message);
            window.location.reload();
        } else {
            alert(response.message);
            return;
        }

        closeModal(); // Modalı kapat
    };

    return (
      <div>
        <button 
            type="button" 
            title="Randevuyu Düzenle"
            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" 
            onClick={() => openModal()}>
            <i className="ki-duotone ki-pencil fs-2"><span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span></i>                                    
        </button>
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Randevu Düzenle</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    
                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="startDate" label="Başlangıç Tarihi">
                                <FormControl 
                                    type="date" 
                                    name="startDate"
                                    defaultValue={moment(restriction.startDate).format('YYYY-MM-DD')}
                                    isInvalid={!isValidStartDate}
                                    onChange={handleItemChange} />
                                <Form.Control.Feedback type="invalid">
                                    Geçerli bir tarih girin.
                                </Form.Control.Feedback>
                            </FloatingLabel>
                        </Form.Group>

                        <Form.Group as={Col}>
                            <FloatingLabel controlId="endDate" label="Bitiş Tarihi">
                                <FormControl 
                                    type="date" 
                                    name="endDate" 
                                    defaultValue={moment(restriction.endDate).format('YYYY-MM-DD')}
                                    isInvalid={!isValidEndDate}
                                    onChange={handleItemChange} />
                                <Form.Control.Feedback type="invalid">
                                    Geçerli bir tarih girin.
                                </Form.Control.Feedback>
                            </FloatingLabel>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col}>
                            <FloatingLabel controlId="description" label="Açıklama">
                                <FormControl 
                                    type="text" 
                                    name="description"
                                    defaultValue={description??""} 
                                    onChange={handleItemChange} />
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Kapat
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Kaydet
                </Button>
            </Modal.Footer>
        </Modal>
      </div>
    )
}

export default (RestrictedAppointmentDatesUpdate)